import moment from "moment";

const stringSorter = (a: string, b: string) => a.localeCompare(b);
const numericalSorter = (a: number, b: number) => a - b;
const dateTimeSorter = (a: string, b: string) => {
  return moment.utc(a).diff(moment.utc(b));
};

export { dateTimeSorter, numericalSorter, stringSorter };
